import { DiagnosisGuideSteps, type PossibleStepSlugs } from '@/legacy-src/components/diagnosis/client/types'
import { LOCALE } from '@/legacy-src/constants/locale.constants'

export const PSYCHIATRY_STEP_SLUG = 'psychiatry'
export const SKIP_SERVICE_STEP_SLUG = 'skip-service'

export const diagnosisFormDefaultValues = {
  lead: 0,
  emotions: 0,
  past: 0,
  personality: 0,
  specialization: [],
  therapyActivities: [],
  sex: '2',
  therapistAgeGroup: '0',
  maxPrice: '',
  name: '',
  language: LOCALE,
}

export const diagnosisContentSteps: PossibleStepSlugs[] = [
  DiagnosisGuideSteps.content1,
  DiagnosisGuideSteps.content2,
  DiagnosisGuideSteps.content3,
  DiagnosisGuideSteps.content4,
  PSYCHIATRY_STEP_SLUG,
]
